export const ElectionStatus = {
    unknown: 0,
    prePublished: 1,
    archived: 2,
    published: 3,
    cancelled: 4
}